import React, { createContext, useContext } from 'react';
import usePerformanceBar from '../hooks/usePerformanceBar';
import PerformanceBar from '../components/ui/PerformanceBar';

const PerformanceBarContext = createContext();

export const usePerformanceBarContext = () => {
  const context = useContext(PerformanceBarContext);
  if (!context) {
    throw new Error('usePerformanceBarContext must be used within a PerformanceBarProvider');
  }
  return context;
};

export const PerformanceBarProvider = ({ children }) => {
  const performanceBar = usePerformanceBar();

  return (
    <PerformanceBarContext.Provider value={performanceBar}>
      {children}
      <PerformanceBar
        isVisible={performanceBar.isVisible}
        onClose={performanceBar.hidePerformanceBar}
        data={performanceBar.data}
      />
    </PerformanceBarContext.Provider>
  );
};

export default PerformanceBarContext;